import { render, staticRenderFns } from "./WeightManagement.vue?vue&type=template&id=a009d67e&scoped=true"
import script from "./WeightManagement.vue?vue&type=script&lang=ts"
export * from "./WeightManagement.vue?vue&type=script&lang=ts"
import style0 from "./WeightManagement.vue?vue&type=style&index=0&id=a009d67e&prod&lang=scss"
import style1 from "./WeightManagement.vue?vue&type=style&index=1&id=a009d67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a009d67e",
  null
  
)

export default component.exports